import { createContext, useContext } from 'react';

export type Rolle = 'admin' | 'planung' | 'standard';

export const ROLLEN: { wert: Rolle; label: string; text: string }[] = [
  { wert: 'admin', label: 'Admin', text: 'darf alles, auch Benutzer und Verteiler verwalten' },
  { wert: 'planung', label: 'Planung', text: 'Gerichte und Wochenplan bearbeiten, Plan versenden' },
  { wert: 'standard', label: 'Standard', text: 'Wochenplan und Gerichte nur ansehen' },
];

// Rolle des angemeldeten Benutzers; ohne Provider (z. B. in Tests) gilt "admin"
export const KontoContext = createContext<Rolle>('admin');

export function useKonto() {
  const rolle = useContext(KontoContext);
  return { rolle, darfBearbeiten: rolle !== 'standard', istAdmin: rolle === 'admin' };
}
